export function getCookie(name: string) {
  const cookieString = '; ' + document.cookie
  const parts = cookieString.split('; ' + name + '=')

  //@ts-ignore
  if (parts.length === 2) return parts?.pop().split(';').shift()
  return null
}
